import { EPosition } from '../shared/enum';
import { IInputSoil } from '../shared/iProject';
import { roundDown, roundTwelveDecimal, roundTwoDecimal, roundUp } from './util';

export const getExpectedWaterTableDepth = (drainPositionDepth: number) => roundTwoDecimal(drainPositionDepth - 0.3);

export const getDrainLineLengthPrimaryDrainageTrench = (slopeLength: number) => slopeLength;

export const getDrainLineLengthSecondaryDrainageTrench = (wheelbase: number) => roundTwoDecimal(0.5 * wheelbase);

export const getHeightOfSaturatedWaterTableBelowDrains = (hasWaterproofMembraneBelowDrain: boolean, drainPositionDepth: number, impermeableLayerDepth: number) =>
    hasWaterproofMembraneBelowDrain ? 0.15 : roundTwoDecimal(impermeableLayerDepth - drainPositionDepth);

export const getNumberOfDrainLinesPrimaryDrainageTrench = (slopeWidth: number, wheelbase: number) => roundTwoDecimal(roundUp(slopeWidth / wheelbase, 0));

export const getNumberOfDrainLinesSecondaryDrainageTrench = (slopeLength: number, wheelbase: number) => roundTwoDecimal(roundDown(slopeLength / wheelbase, 0));

export const getWaterTableLoweringThickness = (drainPositionDepth: number, expectedWaterTableDepth: number) => roundTwoDecimal(drainPositionDepth - expectedWaterTableDepth);

export const getDrainageChimneyLength = (configuration: EPosition, drainUnitLength: number, drainHeight: number) => (configuration == EPosition.Vertical ? drainHeight : drainUnitLength);

export const getDrainageChimneyHeight = (configuration: EPosition, drainUnitLength: number, coverLayer: number, drainHeight: number, drainPositionDepth: number) => {
    let result;
    if (configuration === EPosition.Vertical) {
        if (drainUnitLength + coverLayer + drainHeight <= drainPositionDepth) {
            result = drainUnitLength;
        } else {
            result = drainPositionDepth - drainHeight - coverLayer;
        }
    } else {
        if (drainHeight + coverLayer + drainHeight <= drainPositionDepth) {
            result = drainHeight;
        } else {
            result = drainPositionDepth - drainHeight - coverLayer;
        }
    }
    return roundTwoDecimal(result);
};

export const getFlowConcentrationTime = (catchmentArea: number, mainChannelLength: number, averageCatchmentElevation: number, closureSectionElevation: number) => {
    const numerator = 4 * Math.sqrt(catchmentArea) + 1.5 * mainChannelLength;
    const denominator = 0.8 * Math.sqrt(averageCatchmentElevation - closureSectionElevation);
    return roundTwoDecimal(numerator / denominator);
};

export const getRainfallHeight = (parameterA: number, parameterN: number, flowConcentrationTime: number) => {
    return roundTwoDecimal(parameterA * Math.pow(flowConcentrationTime, parameterN));
};

export const getTotalDrainageDischarge = (curveNumber: number, catchmentArea: number, rainfallHeight: number, flowConcentrationTime: number) => {
    const C125 = 254 * (100 / curveNumber - 1);
    const C126 = 0.05 * C125;
    const C127 = Math.pow(rainfallHeight - C126, 2) / (rainfallHeight - C126 + C125);
    const C128 = C127 / rainfallHeight;

    const numerator = (1 - C128) * catchmentArea * 1000000 * rainfallHeight;
    const denominator = 1000 * flowConcentrationTime * 60 * 60;

    return roundTwoDecimal(numerator / denominator);
};

export const getLayersInSeries = (inputSoil: IInputSoil[]) => {
    let sumThickness = 0;
    inputSoil.forEach(x => (sumThickness += x.thickness!));
    let sumHydraulicConductivity = 0;
    inputSoil.forEach(x => (sumHydraulicConductivity += x.hydraulicConductivity!));
    return roundTwelveDecimal(sumThickness / sumHydraulicConductivity);
};

export const getHydraulicConductivity = (thickness: number, drainedSoilPermeability: number) => (thickness !== 0 ? thickness / drainedSoilPermeability : 0);

export const getCoverLayer = (drainPositionDepth: number, drainHeight: number, drainageChimneyHeight: number) => roundTwoDecimal(drainPositionDepth - drainHeight - drainageChimneyHeight);
